import React from "react";
import { graphql } from "gatsby";
import { Link } from "gatsby";
import g from "glamorous";
import Layout from "../../components/layout";
import Img from "gatsby-image";
import Menu from "../../components/Menu-en";
import Footer from "../../components/Footer-en";
import AdresseSidebar from "../../components/AdresseSidebar-en";
import ContactSidebar from "../../components/ContactSidebar-en";
import VideoBlock from "../../components/VideoBlock-en";
import BioAccueil from "../../components/BioAccueil-en";
import TemoignagesAccueil from "../../components/TemoignagesAccueil-en";
import NewsBlock from "../../components/NewsBlock-en";
import { Container, Row, Col } from "glamorous-grid";
import { Helmet } from "react-helmet";
import { FaPlus } from "react-icons/fa";

export default function Homepage({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const {
    logo,
    lvpa,
    protheses,
    deepplane,
    preserve,
    coolsculpting,
    ultraclear,
  } = data;

  const Wrapper = g.main({
    maxWidth: `1200px`,
    margin: `3em auto 2.5em`,
    "@media(max-width: 767px)": {
      margin: `1em auto 2.5em`,
    },
  });

  const LogoWrapper = g.div({
    backgroundColor: `white`,
    marginBottom: `3em`,
    borderRadius: `6px`,
    border: `1px solid rgba(73,105,126,0.08)`,
    boxShadow: `0 1px 7px rgba(0,0,0,.05)`,
    padding: `1.25em 1em 1.5em .8em`,
    "@media(max-width: 767px)": {
      marginBottom: `.3em`,
    },
  });

  const Adresse = g.div({
    fontSize: `.8em`,
    lineHeight: `1.25em`,
    color: `#3c4d68`,
    opacity: `.75`,
    display: `flex`,
    justifyContent: `flex-end`,
    "@media(max-width: 767px)": {
      display: `none`,
    },
  });

  const H1 = g.h1({
    margin: `.8em 0 .1em 20px`,
    color: `#3c4d68`,
    fontSize: `1.7em`,
    fontWeight: `500`,
    lineHeight: `1.25em`,
    letterSpacing: `0.028em`,
    "@media(max-width: 767px)": {
      fontSize: `1.3em`,
      margin: `0 0 .1em`,
    },
  });

  const H2 = g.h2({
    position: `relative`,
    fontSize: `32px`,
    fontWeight: `500`,
    marginTop: `0.2em`,
    marginBottom: `.5em`,
    "&::after": {
      content: ` `,
      position: `absolute`,
      top: `54%`,
      left: `205px`,
      border: `.063em solid #3c4d68`,
      display: `inline-block`,
      width: `610px`,
    },
    "@media(max-width: 767px)": {
      margin: `.5em 0 .5em`,
      "&::after": {
        content: `none`,
      },
    },
    "@media(max-width: 1100px)": {
      "&::after": {
        content: `none`,
      },
    },
  });

  const Card = g.div({
    backgroundColor: `white`,
    marginTop: `0`,
    marginBottom: `2em`,
    borderRadius: `6px`,
    border: `1px solid rgba(73,105,126,0.08)`,
    boxShadow: `0 1px 7px rgba(0,0,0,.05)`,
    transition: `all 0.15s ease-in-out`,
    ":hover": {
      border: `1px solid rgba(73,105,126,0.18)`,
      boxShadow: `0 1px 10px rgba(0,0,0,.26)`,
      transition: `all 0.15s ease-in-out`,
      transform: `translateY(-2px)`,
    },
    "@media(max-width: 767px)": {
      marginBottom: `1.5em`,
    },
  });

  const Title = g.h3({
    padding: `0 .5em 0 .82em`,
    margin: `.7em 0 .3em`,
    font: `700 18px/1.35em -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`,
  });

  const Text = g.p({
    padding: `0 .5em 0 .8em`,
    marginBottom: `.6em`,
    color: `#1f1f1f`,
  });

  const PlusWrapper = g.div({
    display: `flex`,
    justifyContent: `flex-end`,
    color: `#3c4d68`,
    margin: `0 1.5em .85em`,
    fontSize: `.8em`,
  });

  return (
    <Layout>
      <g.Div margin={`0 auto`} backgroundColor={`#fcfcfc`}>
        <Helmet>
          <title>Dr Cédric Kron | Plastic Surgeon in Paris 17</title>
          <meta
            name="description"
            content="Cosmetic surgeon in Paris, Dr. Kron is a surgeon specialized in plastic, cosmetic and reconstructive surgery, as well as in aesthetic medicine treatments."
          />
          <html lang="en" />
          <link rel="alternate" hreflang="fr" href="https://www.dr-kron.com/" />
          <meta property="og:url" content={`https://www.dr-kron.com/en/`} />
          <meta property="og:type" content="article" />
          <meta
            property="og:title"
            content="Dr Cédric Kron | Plastic Surgeon in Paris 17"
          />
          <meta
            property="og:description"
            content="Cosmetic surgeon in Paris, Dr. Kron is a surgeon specialized in plastic, cosmetic and reconstructive surgery, as well as in aesthetic medicine treatments."
          />
          <meta
            property="og:image"
            content="https://www.dr-kron.com/lifting-visage-lvpa.jpg"
          />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="1034" />
          <meta property="og:image:height" content="584" />

          <meta property="og:locale" content="en_US" />
          <meta property="fb:app_id" content="402235436975681" />
        </Helmet>
        <Menu pathFr="/" />
        <Wrapper>
          <Container
            css={{
              paddingRight: `12px !important`,
              paddingLeft: `12px !important`,
            }}
          >
            <Row>
              <Col>
                <LogoWrapper>
                  <Row>
                    <Col span={{ xs: 12 / 12, lg: 25 / 100 }}>
                      <Img
                        fluid={logo.childImageSharp.fluid}
                        alt="Logo du Dr Cédric Kron, plastic surgeon in Paris"
                        css={{ marginBottom: `.5em` }}
                      />
                    </Col>
                    <Col
                      span={{ xs: 12 / 12, lg: 75 / 100 }}
                      css={{
                        paddingRight: `6px !important`,
                        paddingLeft: `8px !important`,
                      }}
                    >
                      <Adresse>
                        Dr Cédric Kron, plastic surgeon in Paris
                        <br />
                        57 avenue de Villiers - 75017 Paris
                        <br />
                        Phone: (+33) 1 45 62 85 00
                      </Adresse>
                      <H1>
                        Plastic surgeon in Paris - Aesthetic Medicine and
                        Surgery
                      </H1>
                    </Col>
                  </Row>
                </LogoWrapper>
              </Col>
            </Row>

            <Row>
              <Col
                span={{ sm: 12 / 12, lg: 74 / 100 }}
                css={{ backgroundcolor: `white` }}
              >
                <section>
                  <H2>Treatments</H2>
                  <Row>
                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/breast/motiva-preserve/">
                          <Img
                            fluid={preserve.childImageSharp.fluid}
                            alt="Breast augmentation with Motiva Preservé in Paris"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>Motiva Preservé</Title>
                        </Link>
                        <Text>
                          A minimally invasive breast augmentation performed
                          under local anesthesia, with invisible scars and an
                          immediate return to daily activities.
                        </Text>
                        <Link
                          to="/en/breast/motiva-preserve/"
                          title="Information about the minimally invasive Motiva Preservé breast augmentation technique"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>

                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/breast/breast-implants/">
                          <Img
                            fluid={protheses.childImageSharp.fluid}
                            alt="Breast implant plastic surgery"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>Breast implants</Title>
                        </Link>
                        <Text>
                          A breast augmentation should embellish breast shape
                          and size while offering a natural result, consistent
                          with the patient's needs.
                        </Text>
                        <Link
                          to="/en/breast/breast-implants/"
                          title="Information about breast implants"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>

                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/face/facelift-lvpa/">
                          <Img
                            fluid={lvpa.childImageSharp.fluid}
                            alt="Facelift LVPA, plastic surgery of the face"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>LVPA Facelift</Title>
                        </Link>
                        <Text>
                          The LVPA facelift can correct face wrinkles naturally
                          and durably, with invisible scars and social life
                          disruption of only one week.
                        </Text>
                        <Link
                          to="/en/face/facelift-lvpa/"
                          title="Informations about facelift LVPA"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>
                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/face/deep-plane-facelift/">
                          <Img
                            fluid={deepplane.childImageSharp.fluid}
                            alt="Deep plane facelift in Paris"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>Deep Plane Facelift</Title>
                        </Link>
                        <Text>
                          The deep plane facelift repositions the face's deep
                          tissues, acting on the SMAS instead of tightening
                          the skin, for a natural result.
                        </Text>
                        <Link
                          to="/en/face/deep-plane-facelift/"
                          title="Information about the deep plane facelift in Paris"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>
                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/skin/ultraclear-laser/">
                          <Img
                            fluid={ultraclear.childImageSharp.fluid}
                            alt="UltraClear Laser Skin Rejuvenation"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>UltraClear laser</Title>
                        </Link>
                        <Text>
                          Delivers results on skin quality, wrinkles, and spots,
                          while being more comfortable and involving simpler
                          recovery than traditional ablative lasers.
                        </Text>
                        <Link
                          to="/en/skin/ultraclear-laser/"
                          title="UltraClear Laser in Paris"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>
                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/body-contouring/cryolipolysis-coolsculpting/">
                          <Img
                            fluid={coolsculpting.childImageSharp.fluid}
                            alt="Cryolipolysis Coolsculpting fat removal in Paris"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>Coolsculpting</Title>
                        </Link>
                        <Text>
                          Using the action of cold on fat cells, cryolipolysis
                          with Coolsculpting reduces stubborn fat deposits on
                          the abdomen, hips and thighs.
                        </Text>
                        <Link
                          to="/en/body-contouring/cryolipolysis-coolsculpting/"
                          title="Cryolipolysis Coolsculpting treatment in Paris"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>
                    <Col>
                      <PlusWrapper
                        css={{
                          fontSize: `1.6em`,
                          margin: `0 0 1.4em 0`,
                          "@media(max-width: 767px)": {
                            fontSize: `1.35em`,
                            marginTop: `-0.3em`,
                          },
                        }}
                      >
                        <Link
                          to="/en/treatments/"
                          css={{ textureDecoration: `none`, color: `#3c4d68` }}
                        >
                          <FaPlus
                            css={{
                              fontSize: `1em`,
                              padding: `0.1em .35em 0em`,
                              transform: `translateY(4px)`,
                            }}
                          />
                          See all treatments
                        </Link>
                      </PlusWrapper>
                    </Col>
                  </Row>
                </section>
              </Col>

              <Col span={{ sm: 12 / 12, lg: 26 / 100 }}>
                <aside>
                  <NewsBlock />
                  <ContactSidebar about="the treatments performed by Dr. Cédric Kron" />
                  <AdresseSidebar />
                  <VideoBlock />
                </aside>
              </Col>
            </Row>
            <BioAccueil />
            <TemoignagesAccueil />
          </Container>
        </Wrapper>
        <Footer />
      </g.Div>
    </Layout>
  );
}

export const pageQuery = graphql`
  query HomepageQueryEn {
    logo: file(relativePath: { eq: "images/logo-dr-cedric-kron-2.png" }) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 248) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    lvpa: file(relativePath: { eq: "images/lifting-visage-lvpa.jpg" }) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 388) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    protheses: file(
      relativePath: { eq: "images/augmentation-mammaire-protheses.jpg" }
    ) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 388) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    deepplane: file(
      relativePath: { eq: "images/lifting-deep-plane-04.jpg" }
    ) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 388) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    preserve: file(relativePath: { eq: "images/motiva-preserve-1.jpg" }) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 400) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    coolsculpting: file(
      relativePath: { eq: "images/cryolipolyse-coolsculpting.jpg" }
    ) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 400) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    ultraclear: file(relativePath: { eq: "images/ultraclear.jpg" }) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 400) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`;
